import React from "react";

export function IconBadge({
    shape,
    muted,
    accentColor,
    children,
}: {
    shape: "circle" | "diamond" | "triangle" | "square";
    muted?: boolean;
    accentColor?: string;
    children: React.ReactNode;
}) {
    const base =
        shape === "circle"
            ? `rm-icon rm-icon--circle ${muted ? "rm-icon--muted" : ""}`
            : shape === "triangle"
              ? "rm-icon rm-icon--triangle"
              : shape === "square"
                ? "rm-icon rm-icon--square"
                : "rm-icon rm-icon--diamond";

    const iconColor = muted 
        ? undefined 
        : accentColor || 
          (shape === "circle" ? "rgb(76, 175, 80)" : 
           shape === "diamond" ? "#5c5cff" :
           shape === "square" ? "rgb(255, 152, 0)" :
           "rgb(15, 139, 253)");

    return (
        <span className={base} style={iconColor ? { color: iconColor } : undefined}>
            {children}
        </span>
    );
}
